// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"1a5dd121","933":"f987375f"}[chunkId] + ".chunk.js";
};